import axios from "axios";
import Cookies from "js-cookie";

axios.defaults.withCredentials = true;
const SignUpFormHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_NODE_URL}/registration`,
        {
          email: data.email,
          portal_url: data.portal_url,
          password: data.password,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  });
};

const SignUpBasicDataBusinessHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .post(`${process.env.REACT_APP_NODE_URL}/business/portal/new`, data, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status === 200) {
          Cookies.set("portal_id", res.data.data.mpi_id);
          Cookies.set("portal_name_addnew", res.data.data.portal_url);
          data.mpi_id = res.data.data.mpi_id;
          axios
            .post(
              `${process.env.REACT_APP_NODE_URL}/business/basic/new`,
              data,
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              if (res.data.status === 200) {
                resolve(res.data);
              }
            })
            .catch((err) => console.log(err));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  });
};

const SignUpOtpHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_NODE_URL}/registration/new/verify-otp`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const SignUpResendHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .put(
        `${process.env.REACT_APP_NODE_URL}/registration/new/resend-otp`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const SignUpBasicDataHooks = (data) => {
  return new Promise((resolve) => {
    data["mpi_id"] = Cookies.get("portal_id");
    axios
      .post(`${process.env.REACT_APP_NODE_URL}/business/basic/new`, data, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 200) {
          // insert portal info
          axios
            .put(
              `${process.env.REACT_APP_NODE_URL}/business/portal/update`,
              data,
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              if (res.status === 200) {
                // insert personal info
                axios
                  .put(
                    `${process.env.REACT_APP_NODE_URL}/profile/update-profile`,
                    data,
                    {
                      withCredentials: true,
                    }
                  )
                  .then((res) => resolve(res.data));
              } else {
                alert(res.message);
              }
            });
        } else {
          alert(res.message);
        }
      })
      .catch((err) => console.log(err));
  });
};

const SignUpThemeHooks = (data) => {
  data["mpi_id"] = Cookies.get("portal_id");
  return new Promise((resolve) => {
    axios
      .post(`${process.env.REACT_APP_NODE_URL}/business/siteinfo/new`, data, {
        withCredentials: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const SignUpPopularityHooks = (data, formData, fileUplaod) => {
  return new Promise((resolve) => {
    axios
      .post("https://s3bucket-node.superhaves.com/FormalUploadFileInS3", formData)
      .then(async (response) => {
        if (response.data.status === 200) {
          data["mpi_id"] = Cookies.get("portal_id");
          data["ga_analytics_bucket"] = fileUplaod.bucket;
          data["ga_analytics"] = fileUplaod.key;
          axios
            .post(
              `${process.env.REACT_APP_NODE_URL}/business/socialmedia/new`,
              data,
              { withCredentials: true }
            )
            .then((res) => {
              resolve(res.data);
            })
            .catch((err) => console.log(err));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  });
};

const SignUpPopularityUpdateHooks = (data, formData, fileUplaod) => {
  return new Promise((resolve) => {
    if (fileUplaod !== undefined) {
      axios
        .post("https://s3bucket-node.superhaves.com/FormalUploadFileInS3", formData)
        .then(async (response) => {
          if (response.data.status === 200) {
            data["updateData"]["ga_analytics_bucket"] = fileUplaod.bucket;
            data["updateData"]["ga_analytics"] = fileUplaod.key;
            axios
              .put(
                `${process.env.REACT_APP_NODE_URL}/business/socialmedia/update`,
                data,
                { withCredentials: true }
              )
              .then((res) => {
                resolve(res.data);
              })
              .catch((err) => {console.log(err); resolve(err)});
          }
        })
        .catch((error) => {
          console.log(error);
          resolve(error)
        });
    } else {
      axios
        .put(
          `${process.env.REACT_APP_NODE_URL}/business/socialmedia/update`,
          data,
          { withCredentials: true }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => console.log(err));
    }
  });
};

const SignUpStatisticsHooks = (data) => {
  data["mpi_id"] = Cookies.get("portal_id");
  return new Promise((resolve) => {
    axios
      .post(`${process.env.REACT_APP_NODE_URL}/business/stats/new`, data, {
        withCredentials: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const SignUpContentHooks = (data) => {
  data["mpi_id"] = Cookies.get("portal_id");
  if(Cookies.get("portal_name_addnew")===undefined){
    data["portal_url"] = Cookies.get("portal_name");
  }else{
    data["portal_url"] = Cookies.get("portal_name_addnew");
  }
  console.log(data,"contentinfo");
  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_NODE_URL}/business/contentinfo/new`,
        data,
        { withCredentials: true }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const SignUpContentUpdateHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .put(
        `${process.env.REACT_APP_NODE_URL}/business/contentinfo/update`,
        data,
        { withCredentials: true }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const AddNewBusinessBasicDataHooks = () => {
  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_NODE_URL}/profile/view-profile`, {
        withCredentials: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const getPortalInfo = (data) => {
  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_NODE_URL}/business/portal/${data.id}`, {
        withCredentials: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const AddNewBusinessBasicDataUpdateHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/business/basic/update`, data, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status === 200) {
          // insert portal info
          axios
            .put(
              `${process.env.REACT_APP_NODE_URL}/business/portal/update`,
              data,
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              resolve(res.data);
            });
        }
      })
      .catch((err) => console.log(err));
  });
};

const SignUpThemeUpdateHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/business/siteinfo/update`, data, {
        withCredentials: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const SignUpStatisticsUpdateHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/business/stats/update`, data, {
        withCredentials: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const getCategoryList = () => {
  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_NODE_URL}/info/get-category`, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });
};

export {
  SignUpFormHooks,
  SignUpOtpHooks,
  SignUpBasicDataHooks,
  SignUpThemeHooks,
  SignUpPopularityHooks,
  SignUpPopularityUpdateHooks,
  SignUpStatisticsHooks,
  SignUpContentHooks,
  SignUpResendHooks,
  SignUpBasicDataBusinessHooks,
  AddNewBusinessBasicDataHooks,
  getPortalInfo,
  getCategoryList,
  SignUpThemeUpdateHooks,
  SignUpStatisticsUpdateHooks,
  SignUpContentUpdateHooks,
  AddNewBusinessBasicDataUpdateHooks,
};
